<template>
  <div class="jeMassurePage-container col-sm-12">
    <div class="jeMassurePage">
      <div
        v-if="submitted && erreurJeMassure != null"
        class="alert alert-danger text-left global-errors"
      >
        <p>
          {{ erreurJeMassure }}
        </p>
      </div>

      <div
        v-if="erreurGlobale != null"
        class="alert alert-danger text-left global-errors mb-5"
      >
        <p>
          {{ erreurGlobale }}
        </p>
      </div>

      <div class="row title mt-4">
        {{ "je_massure_assurance" | translate(locale) }}
      </div>

      <p class="mes-justificatifs-text mt-3">
        <span
          v-html="
            $options.filters.translate('je_massure_assurance_text', locale)
          "
        ></span>
      </p>

      <p class="mes-justificatifs-text font-weight-bold text-danger mt-3">
        <span
          v-html="
            $options.filters.translate('je_massure_assurance_text_1', locale)
          "
        ></span>
      </p>

      <p
        class="mes-justificatifs-text mt-3"
        v-if="assuranceSaisonPrecedenteText != ''"
      >
        {{ assuranceSaisonPrecedenteText }}
      </p>

      <p class="mes-justificatifs-text mt-3">
        <span
          v-html="
            $options.filters.translate(
              'je_massure_assurance_lien_video',
              locale
            )
          "
        ></span>
      </p>

      <p class="mes-justificatifs-text mt-3">
        {{ "je_massure_assurance_part_1" | translate("fr") }}
        <input
          :class="[
            'input',
            'ml-1',
            'mr-1',
            nomLicencieOuRepresentantLegal === '' &&
            submitted &&
            erreurJeMassure != null
              ? 'is-invalid'
              : ''
          ]"
          type="text"
          placeholder="Nom"
          v-model="nomLicencieOuRepresentantLegal"
        />
        <input
          :class="[
            'input',
            'ml-1',
            'mr-1',
            prenomLicencieOuRepresentantLegal === '' &&
            submitted &&
            erreurJeMassure != null
              ? 'is-invalid'
              : ''
          ]"
          type="text"
          placeholder="Prénom"
          v-model="prenomLicencieOuRepresentantLegal"
        />
        <span
          v-html="
            $options.filters.translate('je_massure_assurance_part_2', locale)
          "
        ></span>
      </p>

      <p class="mes-justificatifs-text mt-4">
        {{ "je_massure_assurance_part_3" | translate("fr") }}
      </p>

      <div
        class="assurance-radio"
        :title="
          assurance.code === 'A'
            ? 'Frais médicaux suite à Accident, Décès suite à Accident, Invalidité permanente suite à Accident'
            : assurance.code === 'B'
            ? 'Frais médicaux suite à Accident, Décès suite à Accident, Invalidité permanente suite à Accident ainsi que la garantie complémentaire Indemnités journalières suite à Accident'
            : assurance.code === 'A+' || assurance.code === 'B+'
            ? 'Garantie invalidité complémentaire à l’option A ou B'
            : ''
        "
        v-for="assurance of this.typesAssurance"
        :key="assurance.code"
        :id="assurance.code"
        @change="updateActiveAssurance(assurance, true)"
      >
        <label>
          <input
            type="radio"
            name="assurance"
            :checked="isAssuranceChecked(assurance.code)"
            :disabled="isAssuranceDisabled(assurance.code)"
          />
          {{ getAssuranceText(assurance) }}
        </label>
      </div>

      <div
        v-if="preinscription_out.data.generalite.assurance.code === 'N'"
        class="alert alert-danger text-left global-errors mt-3"
      >
        <p>
          {{ "je_massure_aucune_garantie_choisie" | translate("fr") }}
        </p>
      </div>

      <p class="mes-justificatifs-text mt-5 mb-3" style="font-style: normal">
        {{
          "je_massure_tableau_garantie_recapitulatif_text" | translate(locale)
        }}
      </p>
      <div class="row">
        <img :src="require('@/assets/tableau_garantie_assurance.png')" />
      </div>

      <!-- TABLEAU DE GARANTIE -->
      <div class="row title mt-5">
        {{ "je_massure_tableau_garantie" | translate(locale) }}
      </div>

      <p class="mes-justificatifs-text mt-3 mb-3" style="font-style: normal">
        {{ "je_massure_tableau_garantie_text" | translate(locale) }}
      </p>
      <div class="text-right mt-5" style="width:90%">
        <b-button
          variant="outline-secondary"
          id="button-visualiser-garantie"
          @click="$bvModal.show('modal-garanties')"
          >VISUALISER LE DOCUMENT</b-button
        >
        <b-button
          class="ml-4"
          variant="outline-secondary"
          id="button-telecharger-garantie"
          @click="downloadGarantieFile"
          >TÉLÉCHARGER</b-button
        >
      </div>

      <!-- NOTICE D'INFORMATION -->
      <div class="row title mt-5">
        {{ "je_massure_notice" | translate(locale) }}
      </div>

      <p
        class="mes-justificatifs-text mt-3 mb-3"
        style="font-style: normal; color: rgb(220, 53, 69)"
      >
        {{ "je_massure_notice_text" | translate(locale) }}
      </p>
      <div class="wrapperPdf" id="wrapperPdfId">
        <pdf
          v-for="i in [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48
          ]"
          :key="i"
          :page="i"
          style="height: 100%"
          id="assurance-pdf"
          :src="require('@/static/assurance.pdf').default"
        ></pdf>
      </div>

      <div class="text-right mt-5" style="width:90%">
        <b-button
          variant="outline-secondary"
          id="button-telecharger"
          @click="downloadAssuranceFile"
          >TÉLÉCHARGER</b-button
        >
        <b-button
          class="ml-4"
          variant="outline-secondary"
          id="button-lu"
          @click="noticeUtilisationLu = true"
          :disabled="isButtonLuDisabled"
          >J'AI LU</b-button
        >
      </div>

      <div
        v-if="submitted && erreurJeMassure != null"
        class="alert alert-danger text-left global-errors mt-5"
      >
        <p>
          {{ erreurJeMassure }}
        </p>
      </div>

      <div
        v-if="erreurGlobale != null"
        class="alert alert-danger text-left global-errors mb-5"
      >
        <p>
          {{ erreurGlobale }}
        </p>
      </div>

      <b-modal centered id="modal-garanties" ref="modal-garanties">
        <div class="wrapperPdfGaranties" id="wrapperPdfGarantie">
          <pdf
            v-for="i in [1]"
            :key="i"
            :page="i"
            style="height: 100%"
            id="garanties-pdf"
            :src="require('@/static/garanties.pdf').default"
          ></pdf>
        </div>

        <template v-slot:modal-title>
          <div></div>
        </template>

        <template v-slot:modal-footer>
          <div></div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import translations from "@/Translations.js";
import preinscriptionAppelsServeur from "@/preinscriptionUtils";
import _ from "lodash";

export default {
  components: {
    pdf
  },
  props: {
    preinscription: Object,
    token: undefined,
    locale: {
      type: String,
      default: "fr"
    }
  },
  data() {
    return {
      preinscription_out: Object,
      typesAssurance: [],
      nomLicencieOuRepresentantLegal: "",
      prenomLicencieOuRepresentantLegal: "",
      submitted: false,
      noticeUtilisationLu: false,
      isButtonLuDisabled: true,
      erreurJeMassure: null,
      erreurGlobale: null, // valorisée dans traitementErreursServeur
      token_out: undefined,
      isAssuranceChoisie: false
    };
  },
  computed: {
    assuranceCode() {
      // on garde si la valeur locale est modifiée
      return this.preinscription_out.data
        ? this.preinscription_out.data.generalite.assurance.code
        : null;
    },
    assuranceSaisonPrecedenteText() {
      if (
        this.preinscription_out.data.generalite.assuranceSaisonPrecedente !=
        null
      ) {
        var libelleSaisonPrecedente = this.getLibelleSaisonPrecedente(
          this.preinscription_out.data.saison.debut,
          this.preinscription_out.data.saison.fin
        );
        return (
          "Lors de la " +
          libelleSaisonPrecedente +
          ", vous avez souscrit à la formule d’assurance Individuelle Accident : " +
          this.preinscription_out.data.generalite.assuranceSaisonPrecedente
            .libelle
        );
      }
      return "";
    }
  },
  watch: {
    token: function() {
      if (this.token) {
        this.token_out = JSON.parse(JSON.stringify(this.token));
      }
    },
    noticeUtilisationLu: {
      handler: function() {
        this.validationPage();
      },
      immediate: true
    },
    assuranceCode: {
      handler: function() {
        this.validationPage();
      },
      immediate: true
    }
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  methods: {
    canContinue() {
      this.submitted = true;
      this.validationPage();
    },
    validationPage() {
      this.erreurJeMassure = null;
      if (
        !this.noticeUtilisationLu ||
        this.preinscription_out.data.generalite.assurance.code === null ||
        this.nomLicencieOuRepresentantLegal === "" ||
        this.prenomLicencieOuRepresentantLegal === ""
      ) {
        this.erreurJeMassure =
          "Vous devez remplir tous les champs modifiables, effectuer un choix dans les assurances, lire les notices d'information puis valider";
        this.$emit("can-continue", { value: false });
      } else {
        this.$emit("can-continue", {
          value: true,
          preinscription: this.preinscription_out
        });
        // document.getElementById("buttonNext").disabled = false;
        // document.getElementById("buttonNext").classList.remove("disabled");
      }
    },
    checkScrollHeight: function() {
      var textElement = document.getElementById("wrapperPdfId");
      if (
        textElement.scrollTop + textElement.offsetHeight >=
        textElement.scrollHeight - 1
      ) {
        this.isButtonLuDisabled = false;
        // document.getElementById("button-lu").disabled = false;
        // document.getElementById("button-lu").classList.remove("disabled");
      }
    },
    updateActiveAssurance(assurance, isAssuranceChoisie) {
      //isAssuranceChoisie est vrai lorsque l'utilisateur choisit manuellement une assurance
      this.isAssuranceChoisie = isAssuranceChoisie;

      this.preinscription_out.data.generalite.assurance.code = assurance.code;
      this.preinscription_out.data.generalite.assurance.libelle =
        assurance.libelle;
    },
    downloadAssuranceFile() {
      preinscriptionAppelsServeur.downloadAssurancePdfFile();
    },
    downloadGarantieFile() {
      preinscriptionAppelsServeur.downloadGarantiePdfFile();
    },
    getTypesAssurance(isReconnected) {
      var that = this;
      // prendre en compte les types pratique du licencié lors de la construction de la liste des choix d'assurance
      preinscriptionAppelsServeur
        .getByName(this.token_out, "TypeAssurance")
        .then(result => {
          let assurancesFiltreesParSaison = _.filter(result.data, function(
            assurance
          ) {
            return (
              assurance.saisonDebut != null &&
              assurance.saisonDebut.id <=
                that.preinscription_out.data.saison.id &&
              (assurance.saisonFin == null ||
                assurance.saisonFin.id >=
                  that.preinscription_out.data.saison.id)
            );
          });
          if (
            this.preinscription_out.data.typesPratique.includes("VS") ||
            this.preinscription_out.data.typesPratique.includes("VT") ||
            this.preinscription_out.data.typesPratique.includes("VI")
          ) {
            that.typesAssurance = _.filter(assurancesFiltreesParSaison, [
              "typePratique",
              "V"
            ]);

            // Ajouter l'option 'Pas d'assurance'
            [].push.apply(
              that.typesAssurance,
              _.filter(assurancesFiltreesParSaison, ["code", "N"])
            );
          } else {
            that.typesAssurance = _.filter(assurancesFiltreesParSaison, [
              "typePratique",
              null
            ]);
          }

          that.typesAssurance = _.orderBy(
            that.typesAssurance,
            ["ordre"],
            ["asc"]
          );

          // Mettre le choix 'Pas d'assurance' en dernier
          that.typesAssurance = _.sortBy(that.typesAssurance, ({ code }) =>
            code === "N" ? 1 : 0
          );
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getTypesAssurance,
            argsArray
          );
        });
    },
    isAssuranceChecked(assuranceCode) {
      if (this.isAssuranceChoisie == true) {
        /* l'utilisateur avait choisi une assurance,
        pas besoin de cocher une assurance par défaut */
        return false;
      }

      let assuranceDefaut = _.first(this.typesAssurance);

      if (this.preinscription_out.data.generalite.assurance.code != null) {
        if (this.preinscription_out.data.generalite.assurance.code == "N") {
          let isChecked = assuranceCode === assuranceDefaut.code;
          if (isChecked == true) {
            this.updateActiveAssurance(assuranceDefaut, false);
          }

          return isChecked;
        }

        return (
          this.preinscription_out.data.generalite.assurance.code ==
          assuranceCode
        );
      }

      if (
        this.preinscription_out.data.generalite.assuranceSaisonPrecedente !=
        null
      ) {
        if (
          this.preinscription_out.data.generalite.assuranceSaisonPrecedente
            .code === "N"
        ) {
          /* s'il a été sélectionné 'N' sur sa licence,
           * on sélectionnera automatiquement 'Formule A' ou 'Formule A gratuite' (pour les VxE) */
          let isChecked = assuranceCode === assuranceDefaut.code;
          if (isChecked == true) {
            this.updateActiveAssurance(assuranceDefaut, false);
          }

          return isChecked;
        } else {
          let isChecked =
            assuranceCode ===
            this.preinscription_out.data.generalite.assuranceSaisonPrecedente
              .code;
          if (isChecked == true) {
            this.updateActiveAssurance(
              this.preinscription_out.data.generalite.assuranceSaisonPrecedente,
              false
            );
          }

          return isChecked;
        }
      }

      //Le club prend en charge une 'Formule ...'
      let assurancesOrganisme = this.getAssuranceOrganisme();
      if (!_.isEmpty(assurancesOrganisme)) {
        assuranceDefaut = _.first(assurancesOrganisme);
      }

      let isChecked = assuranceCode === assuranceDefaut.code;
      if (isChecked == true) {
        this.updateActiveAssurance(assuranceDefaut, false);
      }
      return isChecked;
    },
    isAssuranceDisabled(assuranceCode) {
      if (assuranceCode === "N") {
        //Si on propose une assurance 'VxE', ce n'est pas possible de choisir 'Pas d'assurance'
        if (
          this.preinscription_out.data.typesPratique.includes("VS") ||
          this.preinscription_out.data.typesPratique.includes("VT") ||
          this.preinscription_out.data.typesPratique.includes("VI")
        ) {
          return true;
        }

        //Le club prend en charge une 'Formule ...', ce n'est pas possible de choisir 'Pas d'assurance'
        let assurancesOrganisme = this.getAssuranceOrganisme();
        if (!_.isEmpty(assurancesOrganisme)) {
          return true;
        }
      }

      return false;
    },
    getAssuranceText(assurance) {
      //Le club prend en charge une 'Formule ...'
      let assurancesOrganisme = this.getAssuranceOrganisme();
      if (!_.isEmpty(assurancesOrganisme)) {
        let assuranceOrganisme = _.find(assurancesOrganisme, function(e) {
          return e.code === assurance.code;
        });

        if (assuranceOrganisme) {
          return (
            assurance.libellePreinscription + " (prise en charge par le club)"
          );
        }
      }

      return assurance.libellePreinscription;
    },
    getAssuranceOrganisme() {
      let assurancesOrganismeFilterByType = [];
      if (!_.isEmpty(this.preinscription_out.data.assuranceOrganisme)) {
        if (
          this.preinscription_out.data.typesPratique.includes("VS") ||
          this.preinscription_out.data.typesPratique.includes("VT") ||
          this.preinscription_out.data.typesPratique.includes("VI")
        ) {
          assurancesOrganismeFilterByType = _.filter(
            this.preinscription_out.data.assuranceOrganisme,
            ["type", "V"]
          );
        } else {
          assurancesOrganismeFilterByType = _.filter(
            this.preinscription_out.data.assuranceOrganisme,
            ["type", null]
          );
        }

        assurancesOrganismeFilterByType = _.orderBy(
          assurancesOrganismeFilterByType,
          ["ordre"],
          ["asc"]
        );
      }

      return assurancesOrganismeFilterByType;
    },
    getLibelleSaisonPrecedente(dateDebut, dateFin) {
      // retourne le libelle de la saison precedente
      return preinscriptionAppelsServeur.getLibelleSaisonPrecedente(
        dateDebut,
        dateFin
      );
    }
  },
  created() {
    // la clone preinscription_out est utilisé dans le template et il faut l'initialiser avant mounted
    this.preinscription_out = JSON.parse(JSON.stringify(this.preinscription));

    // la clone token_out est utilisée pour pouvoir mettre a jour le token si la session a expiré (on peut pas modifier directement un prop)
    if (this.token) {
      this.token_out = JSON.parse(JSON.stringify(this.token));
    }
  },
  mounted() {
    // document.getElementById("buttonNext").disabled = true;

    // eventListener pour activer le bouton 'J'ai lu' quand on a été jusqu'en bas du document
    document
      .getElementById("wrapperPdfId")
      .addEventListener("scroll", this.checkScrollHeight, false);

    this.getTypesAssurance(false /*isReconnected*/);

    this.$emit("can-continue", { value: false });
  },
  updated() {
    document
      .getElementById("wrapperPdfId")
      .addEventListener("scroll", this.checkScrollHeight, false);
  }
};
</script>

<style scoped>
.wrapperPdf,
.wrapperPdfGaranties {
  width: 90%;
  max-height: 500px;
  margin-top: 20px;
  overflow-y: scroll;
  /* Tip to mobile */
  -webkit-overflow-scrolling: touch;
  -moz-overflow-scrolling: touch;
  -ms-overflow-scrolling: touch;
  overflow-scrolling: touch;
}

.wrapperPdfGaranties {
  width: 100%;
  margin-top: 0px;
}

.input {
  padding: 5px 10px;
  border: solid 1px #6c757d2b !important;
}

.mes-justificatifs-text {
  font-style: italic;
}

#button-lu,
#button-telecharger,
#button-telecharger-garantie,
#button-visualiser-garantie {
  padding: 5px 50px;
  border-color: #001245 !important;
  color: #000000 !important;
  font-family: Lato;
  font-size: 12px;
  font-weight: bold;
}

#button-visualiser-garantie {
  padding: 5px 30px;
}

#button-lu:disabled {
  background-color: #d8d8d83d;
  cursor: default;
}

.assurance-radio {
  text-align: left;
  margin-left: 10px;
  margin-bottom: 10px;
  font-family: Lato;
}

.assurance-radio label input {
  vertical-align: bottom;
  margin-right: 10px;
}

.mes-justificatifs-text .is-invalid {
  border-color: #dc3545 !important;
}

.mes-justificatifs-text .is-invalid:focus {
  outline-color: #dc3545;
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

/* laptops & desktops */
@media (min-width: 1025px) {
  .jeMassurePage {
    margin: 3rem 8rem;
  }
}

/* mobile phone */
@media (max-width: 480px) {
  .jeMassurePage {
    margin: 10px 15px;
  }

  .assurance-radio label {
    font-size: 13px;
  }

  .wrapperPdf {
    width: 100%;
  }

  .input {
    padding: 5px 0;
    margin: 3px 0;
  }

  #button-telecharger,
  #button-telecharger-garantie,
  #button-visualiser-garantie,
  #button-lu {
    margin: 0.4em auto;
    width: 200px;
  }
}

/* tablet */
@media (min-width: 481px) and (max-width: 1024px) {
  .jeMassurePage {
    margin: 3rem 3rem;
  }

  .wrapperPdf {
    width: 100%;
  }
}
</style>
